module.exports = __webpack_public_path__ + "img/ic_woman.65b045eb.svg";